// removed by extract-text-webpack-plugin
module.exports = {"social":"src-components-Social----index-module---social---3uuyL","primaryImage":"src-components-Social----index-module---primaryImage---1pWPH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Social/index.module.scss
// module id = 340
// module chunks = 152909308826437